var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57143 0L2 3.57143L5.57143 7.14286",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.7857C2.5 12.2691 2.93987 13.7191 3.76397 14.9524C4.58809 16.1858 5.75943 17.1471 7.12987 17.7148C8.50031 18.2824 10.0083 18.431 11.4632 18.1416C12.918 17.8523 14.2544 17.1378 15.3033 16.089C16.3521 15.0401 17.0666 13.7037 17.3559 12.2489C17.6453 10.794 17.4967 9.28602 16.9291 7.91558C16.3614 6.54513 15.4001 5.37379 14.1668 4.54968C12.9334 3.72558 11.4834 3.28571 10 3.28571H3.21429",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerate);
export default __webpack_public_path__ + "static/media/Regenerate.5fe99846fb543f7c238b69c4eeef6ebc.svg";
export { ForwardRef as ReactComponent };